export default __webpack_public_path__ + "static/media/Ana_Tajder_AHV_In_Moms_We_Trust.d3dd8e07.jpg";